export const USER_STATUS_INACTIVE = 0;
export const USER_STATUS_ACTIVE = 1;